import React from 'react';
import cn from '@/utils/cn';
import I18n from 'i18n-js';
import { TABLE_HEADER_CLASS } from '../utils';
import SortingCaret from './SortingCaret';

type TableHeaderProps = {
  className?: string,
  colSortKey?: string,
  sorted: {
    key: string
    order: string
  },
  label?: string,
  handleSort?: (key: string) => void,
};

const TableHeader = ({ className, colSortKey, sorted, label, handleSort } : TableHeaderProps) => (
  <th
    className={cn(TABLE_HEADER_CLASS, 'tw-gap-2', className)}
    onClick={() => handleSort(colSortKey)}
  >
    {I18n.t(label)}
    <SortingCaret isSorted={sorted.key === colSortKey} order={sorted.order} />
  </th>
);

export default TableHeader;
